import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import JobInboxAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/JobInboxAppIcon';

const screenshotStyles = {
  display: 'block',
  width: 600,
  maxWidth: '100%',
};

const JobInboxStrategy = {
  previewInfo: {
    name: 'Job Inbox',
    iconSvg: <JobInboxAppIcon size="xlarge" />,
    newTab: false,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/sjjy2olsop?videoFoam=true%22&autoPlay=false',
  },
  headerInfo: {
    name: 'Job Inbox',
    category: 'Help grow your business with more opportunities',
    details: (
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography paragraph>
            As a Housecall Pro customer, you now have access to our network of thousands of jobs.
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <JobInboxAppIcon size="xlarge" />,
  },
  sellingPoints: {
    description: (
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>How does it work?</Typography>
          <ul>
            <li>You’ll receive a notification with a brief job description.</li>
            <li>You will have a limited amount of time to review the job and accept it.</li>
            <li>
              Once you accept the job, use the Housecall Pro app as you normally would. We will be right by your side!
            </li>
          </ul>
        </Grid>
        <Grid item xs={12} align="center">
          <img
            src="https://static-assets.housecallpro.com/app_store/apps/job_inbox/job_inbox_combined_v3.png"
            alt=""
            style={screenshotStyles}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            <em>
              *Note*: You are not bidding against other Housecall Pro users. You will receive exclusive first access,
              but if you decline a job, it will be passed to the next pro.
            </em>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>Who are the partners?</Typography>
          <Typography paragraph>
            We carefully source jobs from trusted partners that share our core value to “champion the pro.”
          </Typography>
          <Typography paragraph>
            Each partner has their own requirements for Pros to complete when accepting their jobs. But don’t worry,
            they’re simple and straightforward. Step by step instructions will be delivered to you.
          </Typography>
          <Typography paragraph>
            You can enable or disable individual partners you’d like to receive jobs and leads from.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>Other requirements:</Typography>
          <Typography paragraph>
            In order to get paid by the job provider, you must connect your bank account and be eligible to receive
            credit card payments in{' '}
            <Link href="https://pro.housecallpro.com/pro/my_money" rel="noopener" target="_blank">
              My Money.
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>Why should I enable this integration?</Typography>
          <Typography paragraph>
            Get real jobs and leads delivered right to you. Let us help you fill your pipeline, grow your customer base,
            and book more jobs on your calendar.
          </Typography>
          <Typography paragraph>
            To learn more visit our{' '}
            <Link
              href="https://help.housecallpro.com/en/collections/75094-app-store#job-inbox"
              rel="noopener"
              target="_blank"
            >
              help center.
            </Link>
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: false,
    hideCard: true,
  },
};

export default JobInboxStrategy;
